import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { REVOKE_IMPERSONATION_RESOURCE, IMPERSONATION_REQUESTS_RESOURCE } from '../constants';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';

const revokeImpersonationService = ComposedComponent =>
  reduxFetch([
    {
      resource: REVOKE_IMPERSONATION_RESOURCE,
      method: 'put',
      request: (id, callback, t) => ({
        url: apiRoutes.revokeImpersonation(id),
        meta: {
          removeFromOtherList: {
            resource: IMPERSONATION_REQUESTS_RESOURCE,
            idProp: 'id',
            id,
          },
          callback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'terminateImpersonationFailed'),
            onSuccessMessage: t('terminateImpersonationSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default revokeImpersonationService;
